import { SingularNoun } from '../../types'

const заебумба: SingularNoun = {
  type: 'singular noun',
  nominativeSingular: 'заебумба',
  genitiveSingular: 'заебумбы',
  dativeSingular: 'заебумбе',
  accusativeSingular: 'заебумбу',
  instrumentalSingular: 'заебумбой',
  prepositionalSingular: 'заебумбе',
}

export default заебумба
